import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { InputType } from '../../proptypes';
import { humanizeList } from '../../utils';
import {
  getModalSplitSharedMobility,
  getModalSplitNonMotorizedTransit,
  getModalSplitPublicTransit,
} from '../../store/selectors';

const GoalSummary = (props) => {
  // investments... these are all NUMBERS
  // Refactor this in future to support booleans too...
  const {nonMotorizedTransit, publicTransit, sharedMobility} = props;

  const investments = [nonMotorizedTransit, publicTransit, sharedMobility ];
  // only display invesment if it had a value of greater than or equal to 1
  const usedInvestments = investments
                            .filter(investment => investment.value >= 1)
                            .map(investment => investment.name);
  const didInvest = usedInvestments.length > 0;

  return (
    <React.Fragment>
      <p>{ didInvest ?
          `You chose to invest in ${humanizeList(usedInvestments)}.` :
          'You did not invest in any specific transportation mode.'}</p>
    </React.Fragment>
  );
}

// Todo: should this just accept a list of investment types in future?
// For now, we'll just be strict, since we don't want to display all input params...
GoalSummary.propTypes = {
  nonMotorizedTransit: InputType.isRequired,
  publicTransit: InputType.isRequired,
  sharedMobility: InputType.isRequired,
  scenarioKey: PropTypes.string.isRequired,
}

const mapStateToProps = (state, props) => ({
  // intensities,
  nonMotorizedTransit: getModalSplitNonMotorizedTransit(state, props),
  publicTransit: getModalSplitPublicTransit(state, props),
  sharedMobility: getModalSplitSharedMobility(state, props),
})


export default connect(mapStateToProps, null)(GoalSummary);



// WEBPACK FOOTER //
// ./src/components/scenarioCard/goalSummary.js